import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    getErrorMessage(error: HttpErrorResponse): string {
        let errorMessage = error.message;
        if (typeof error.error?.error?.message === 'string') {
            errorMessage = error.error.error.message;
        }

        switch (error.status) {
            case 304:
                return `Not Modified. Details: ${errorMessage}`;
            case 400:
                return `Bad request. Please check your input data. Details: ${errorMessage}`;
            case 401:
                return `You are not authorized to access this resource. Please log in. Details: ${errorMessage}`;
            case 403:
                return `You do not have permission to access this Hexagon section. Please discuss this with the manager. Details: ${errorMessage}`;
            case 404:
                return `The requested resource was not found. Details: ${errorMessage}`;
            case 408:
                return `The request timed out. Please try again later. Details: ${errorMessage}`;
            case 413:
                return `The request payload is too large. Please reduce the size. Details: ${errorMessage}`;
            case 422:
                return `Unprocessable entity. Please review your input data. Details: ${errorMessage}`;
            case 429:
                return `Too many requests. Please wait and try again later. Details: ${errorMessage}`;
            case 500:
                return `An internal server error occurred. Please try again later. Details: ${errorMessage}`;
            case 502:
                return `Bad gateway. Please try again later. Details: ${errorMessage}`;
            case 503:
                return `The service is temporarily unavailable. Please try again later. Details: ${errorMessage}`;
            case 504:
                return `The server took too long to respond. Please try again later. Details: ${errorMessage}`;
        }

        return 'An error occurred. See details in the console. ' + errorMessage;
    }
}